import { AbstractLocaleMessageObject } from "@/i18n/AbstractLocaleMessageObject"

export class SystemErrorJa extends AbstractLocaleMessageObject {
  readonly toLogin: string = "ログイン画面へ"
}
